const preFetchImage = (src: string): HTMLImageElement | null => {
  if (src) {
    const img = new Image();
    img.src = src;
    return img;
  }
  return null;
};

export default preFetchImage;
